import $ from 'jquery';
import MarkerClusterer from '@googlemaps/markerclustererplus';

export default class PracticeMap {
    constructor() {
        this.toggleFilters();
        this.toggleSurgeries();
        this.chooseOptions();
        this.practiceMapConfig();
        this.searchPractices();
    };

    toggleFilters() {
        $('.js-practice-map__select-wrapper').on('click', function() {
            const $toggler = $(this);

            $toggler.toggleClass('is-active');

            $toggler.next().slideToggle();
        });
    };

    toggleSurgeries() {
        $('.js-practice-map__result-toggler').on('click', function() {
            const $toggler = $(this);

            $toggler.toggleClass('is-active');

            $toggler.closest('.js-practice-map__result').find('.js-practice-map__result-content').slideToggle();
        });
    };

    chooseOptions() {
        const self = this;

        $('.js-practice-map__option').on('click', function(e) {
            let practice_types_selected = [];
            let option_text;
            let input;
            let val;
            const checkboxes_total = $('.js-practice-map__type-option');
            const clicked_type = $(this).data('type');

            if (clicked_type == 'type') {
                if ($(this).data('value') == 'all') {
                    const checkBoxes = $('.js-practice-map__option input:checkbox');

                    // Check all checboxes which aren't already checked
                    checkBoxes.prop("checked", !checkBoxes.prop("checked"));

                    // Set checkbox wording
                    option_text = vp_js_trans.select_types;
                } else {
                    // Push values of each selected checkbox to practice_types_selected var
                    $('.js-practice-map__option input:checked').each(function() {
                        practice_types_selected.push($(this).attr('value'));
                    });

                    // Set checkbox wording
                    if (practice_types_selected.length == 0 || practice_types_selected.length == checkboxes_total.length) {
                        option_text = vp_js_trans.select_types;
                    } else if (practice_types_selected.length == 1) {
                        if (practice_types_selected[0] == 'vet') {
                            option_text = vp_js_trans.small_animals;
                        } else {
                            option_text = practice_types_selected[0];
                        };
                    } else {
                        option_text = vp_js_trans.types;
                    };
                };
            } else {
                // Get checked region
                input = $(this).closest('.js-practice-map__select-filter').data('input');
                val = $(this).data('value');

                // Set checkbox wording
                option_text = $(this).text();

                self.populateValues(input, val);
            };

            // Update checkbox wording
            $(this).closest('.js-practice-map__select-filter').find('.js-practice-map__select-wrapper li').replaceWith('<li>' + option_text + '</li>');

            // Close filters when region is selected
            if (clicked_type == 'practice_region') {
                $(this).closest('.js-practice-map__select-filter').find('.js-practice-map__select-options').slideToggle();
            };

            // If a region has been set, trigger the form
            // if (input !== undefined && val !== undefined) {
            //     self.populateValues(input, val).then(function() {
            //         $('.js-practice-map__form').trigger('submit');
            //     });
            // };
        });
    };

    practiceMapConfig() {
        const self = this;

        if ($('.js-practice-map__map').length) {
            $('.js-practice-map__map').each(function() {
                const map_id = $(this).attr('id');
                const latlng = $(this).data('latlng').split(',');
                const map_var = 'map_' + map_id;

                // For each instance of '.js-practice-map', create a practice map with the required options
                self.createPracticeMap(map_id, latlng, map_var);
            });
        };
    };

    // New search practices
    searchPractices() {
    const self = this;
    const $practiceMap = $('.js-practice-map__form');
    let doingPracticeSearch = false;
    console.log("Document is ready");

    // Extend the jQuery submit event to support extra parameters
    $.event.special.submit = {
        setup: function() {
            if (this.tagName && this.tagName.toLowerCase() !== 'form') return false;
            $.event.add(this, 'click._submit keypress._submit', function(e) {
                var elem = e.target;
                var type = elem.type;
                if ((type === 'submit' || type === 'image') && !elem.disabled) {
                    e.delegateTarget._submit_bubble = true;
                }
            });
        },
        postDispatch: function(event) {
            if (event.delegateTarget._submit_bubble) {
                delete event.delegateTarget._submit_bubble;
                if (this.parentNode && !event.isTrigger) {
                    $.event.simulate('submit', this.parentNode, event);
                }
            }
        },
        teardown: function() {
            if (this.tagName && this.tagName.toLowerCase() !== 'form') return false;
            $.event.remove(this, '._submit');
        }
    };

    // Trigger a form submit when various conditions are met
    $('.my-locations').on('click', function(event) {
        console.log("Clicked .my-locations");
        event.preventDefault(); // Prevent the default action

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {
                const latitude = position.coords.latitude;
                const longitude = position.coords.longitude;

                // Display coordinates in the input fields
                $('#mylat').val(latitude);
                $('#mylang').val(longitude);
                console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);

                // Update query string params with set filters
                $practiceMap.data('customAction', 'load_practice_search_results').trigger('submit');
            }, function(error) {
                // Handle geolocation errors
                console.error('Error getting geolocation:', error.message);
            });
        } else {
            alert('Geolocation is not supported by this browser.');
        }
    });

    $('.js-practice-map__type-option').on('change', function() {
        console.log("Changed .js-practice-map__type-option");
        $practiceMap.removeData('customAction').trigger('submit');
    });

    $('[data-type="practice_region"]').on('click', function() {
        console.log("Changed .js-practice-map__type-practice_region");
        $practiceMap.removeData('customAction').trigger('submit');
    });

    $practiceMap.on('submit', function(event) {
        console.log("Submit triggered");
    
        var locationInput = $('input[name="location"]').val();
        var postcodePattern = /^[A-Z]{1,2}[0-9][0-9]?[A-Z]?\s?[0-9][A-Z]{2}$/i; // Pattern to identify UK postcodes
    
        if (postcodePattern.test(locationInput)) {
            // If the location is a valid UK postcode, submit the form normally (full page refresh)
            console.log("Valid postcode detected, performing full page refresh");
            return true; // Allow normal form submission
        }
    
        // If not a postcode, continue with AJAX request
        event.preventDefault(); // Prevent the default action for AJAX search
        var customAction = $(this).data('customAction');
        console.log("Custom action received:", customAction);
    
        // Don't do anything if a search is already being run
        if (doingPracticeSearch) {
            console.log("Search already in progress");
            return false;
        }
    
        // Determine the action to use
        var action = customAction ? customAction : "load_practice_search_results";
        console.log("Action to be used:", action);
    
        // Update query string params with set filters
        self.updateQueryString();
    
        // Run the AJAX
        jQuery.ajax({
            type: "POST",
            url: admin_ajax_url, 
            data: {
                action: 'load_practice_search_results',
                query: window.location.search,
                mylatitude: $('input[name="mylatitude"]').val(),
                mylongitude: $('input[name="mylongitude"]').val()
            },
            dataType: "json",
            beforeSend: function() {
                // Set doingPracticeSearch to true so we don't get other searches interfering
                doingPracticeSearch = true;
            },
            success: function(data) {
                // Set doingPracticeSearch to false so we can run another query
                doingPracticeSearch = false;
    
                // Populate front-end with results
                $('.js-practice-map__results').html(data.results);
    
                // Activate the surgery accordions
                self.toggleSurgeries();
    
                if ($('.js-practice-map__map').length) {
                    $('.js-practice-map__map').each(function() {
                        const map_id = $(this).attr('id');
                        const latlng = $(this).data('latlng').split(',');
                        const map_var = 'map_' + map_id;
    
                        // For each instance of '.js-practice-map', create a practice map with the required options
                        self.createPracticeMap(map_id, latlng, map_var);
                    });
    
                    // Remove the map overlay
                    $('.js-practice-map__map-overlay').fadeOut();
                }
            },
            error: function(errorThrown) {
                console.log(errorThrown);
            }
        });
    
        return false;
    });
    

    console.log("Event listeners attached");
};

            

    populateValues(input, val) {
        return new Promise(function (resolve, reject) {
            $('input[name=' + input + ']').val(val);
            resolve();
        });
    };

    updateQueryString() {
        // Get form params
        const region = $('input[name=practice_region]').val();
        const location = $('input[name=location]').val();
        let practice_types_selected = [];
        let location_query_string;

        $('.js-practice-map__type-option:checked').each(function() {
            practice_types_selected.push($(this).attr('value'));
        });

        // Set practice region URL param
        const practice_region_query_string = '?practice_region=' + region;

        // Set practice location URL param
        if (location === '') {
            location_query_string = '';
        } else {
            location_query_string = '&location=' + location;
        };

        // Set practice type(s) URL param
        let types_query_string = '';

        for (var x = 0; x <= practice_types_selected.length; x++) {
            if (practice_types_selected[x] !== undefined) {
                types_query_string += '&types[]=' + practice_types_selected[x];
            };
        };

        // Update URL
        window.history.pushState({}, "", window.location.origin + window.location.pathname + practice_region_query_string + location_query_string + types_query_string);
    };

    createPracticeMap(map_id, latlng, map_var) {
        const gmarkers = [];
        const bound = new google.maps.LatLngBounds();
        const infowindow = new google.maps.InfoWindow({
            maxWidth: 200
        });

        map_var = new google.maps.Map(document.getElementById(map_id), {
            zoom: site_lang == 'ga' ? 7.5 : 12,
            backgroundColor: '#eeeeee',
            center: site_lang == 'ga' ? new google.maps.LatLng('53.3781516', '-9.3385253') : new google.maps.LatLng(latlng[0], latlng[1]),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [
                {
                  "featureType": "administrative.land_parcel",
                  "elementType": "labels",
                  "stylers": [
                    {
                      "visibility": "off"
                    }
                  ]
                },
                {
                  "featureType": "poi",
                  "elementType": "labels.text",
                  "stylers": [
                    {
                      "visibility": "off"
                    }
                  ]
                },
                {
                  "featureType": "poi.business",
                  "stylers": [
                    {
                      "visibility": "off"
                    }
                  ]
                },
                {
                  "featureType": "road",
                  "elementType": "labels.icon",
                  "stylers": [
                    {
                      "visibility": "off"
                    }
                  ]
                },
                {
                  "featureType": "road.highway",
                  "elementType": "geometry.stroke",
                  "stylers": [
                    {
                      "visibility": "simplified"
                    }
                  ]
                },
                {
                  "featureType": "road.local",
                  "elementType": "labels",
                  "stylers": [
                    {
                      "visibility": "off"
                    }
                  ]
                },
                {
                  "featureType": "transit",
                  "stylers": [
                    {
                      "visibility": "off"
                    }
                  ]
                },
                {
                  "featureType": "water",
                  "elementType": "geometry.fill",
                  "stylers": [
                    {
                      "color": "#8bb7fe"
                    },
                    {
                      "saturation": 5
                    }
                  ]
                }
              ],
            addressControlOptions: {
                position: google.maps.ControlPosition.LEFT_BOTTOM
              },
            scrollwheel: false,
            navigationControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            panControl: false,

        });

        function createSurgeryMarker(latlng, title, html, markerType) {
            const iconBase = asset_url + '/img/map/';
            var icon;

            if(site_lang === 'fr' || site_lang === 'es') {
                var icon = iconBase + 'mixed.png';
            } else {
                var icon = iconBase + markerType + '.png';
            };

            const marker = new google.maps.Marker({
                position: latlng,
                map: map_var,
                title: title,
                icon: icon
            });

            marker.addListener('click', function() {
                // map_var.setZoom(14);
                map_var.setCenter(marker.getPosition());
            });

            google.maps.event.addListener(marker, 'click', function() {
                infowindow.setContent(html);
                infowindow.open(map_var, marker);
            });

            return marker;
        };

        for (let i = 0; i < surgery_markers.length; i++) {
            const latlng = new google.maps.LatLng(surgery_markers[i]['lat'], surgery_markers[i]['lng']);

            gmarkers.push(createSurgeryMarker(latlng, surgery_markers[i]['practice'], surgery_markers[i]['html'], surgery_markers[i]['type']));

            bound.extend(new google.maps.LatLng(surgery_markers[i]['lat'], surgery_markers[i]['lng']));
        };

        const styles = [{
            anchorIcon: [40, 40],
            height: 40,
            url: asset_url + '/img/map/cluster.png',
            width: 40,
            className: 'gmap-cluster'
        }];

        if (gmarkers.length > 0) {
            $('.c-practice-map__map-overlay').fadeOut();

            window.setTimeout(function() {
                let markerCluster;

                if(site_lang == 'ga') {
                    markerCluster = new MarkerClusterer(map_var, gmarkers, {styles: styles});
                } else {
                    markerCluster = new MarkerClusterer(map_var, gmarkers, {styles: styles, averageCenter: true, minimumClusterSize: 10, gridSize: 50});
                };

                markerCluster.fitMapToMarkers();

                if (gmarkers.length == 1) {
                    map_var.setZoom(14);
                };
            }, 100);
        } else {
            $('.c-practice-map__map-overlay').fadeIn();

            map_var.setZoom(6);
        };
    };
};

// Scroll the list of practices to display the practice associated with the point clicked on the map
document.addEventListener('DOMContentLoaded', () => {
    console.log('DOM fully loaded and parsed');

    // Use event delegation to handle clicks on dynamically created divs
    document.body.addEventListener('click', function(event) {
        const target = event.target.closest('div[role="button"]');
        if (target) {
            event.preventDefault(); // Prevent any default action

            // Read the title attribute
            const title = target.getAttribute('title').trim();
            console.log('Title being looked for:', title); // Log the title being looked for

            // Find the corresponding block in the scrollable div
            const scrollableDiv = document.querySelector('.c-practice-map__content-wrapper');
            if (!scrollableDiv) {
                console.error('Scrollable div not found');
                return;
            }

            const titleElements = scrollableDiv.querySelectorAll('.c-practice-map__result-title');
            console.log('Found title elements:', titleElements.length); // Log the number of title elements found

            const targetBlock = Array.from(titleElements).find(titleElement => {
                const titleText = titleElement.textContent.trim();
                console.log('Comparing with title element:', titleText); // Log each title being compared
                return titleText === title;
            })?.closest('.c-practice-map__result');

            if (targetBlock) {
                console.log('Target block found:', targetBlock); // Log the found target block

                // Calculate the top position of the target block relative to the scrollable div
                const targetPosition = targetBlock.offsetTop - scrollableDiv.offsetTop;
                console.log('Target position:', targetPosition); // Log the target position

                // Scroll the div to the target position
                scrollableDiv.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });

                // Add the 'is-active' class to the button within the target block
                const button = targetBlock.querySelector('button');
                if (button) {
                    button.classList.add('is-active');
                    console.log('Added "is-active" class to button:', button);
                } else {
                    console.warn('Button not found in the target block');
                }

                // Change the display property of the target content div to 'block'
                const contentDiv = targetBlock.querySelector('.c-practice-map__result-content');
                if (contentDiv) {
                    contentDiv.style.display = 'block';
                    console.log('Changed display to "block" for content div:', contentDiv);
                } else {
                    console.warn('Content div not found in the target block');
                }
            } else {
                console.warn('Target block not found for title:', title); // Warn if target block is not found
            }
        }
    });
});
